import { toast } from "react-toastify";
import { dateDiffInDays } from "./date";
import { walletShort } from "./dataShort";

export const toastExpiredWallets = (wallets, authWallet) => {
  for (const wallet of wallets) {
    if (
      wallet.wallet != authWallet &&
      wallet.dateEnd != null && // null - когда кошелек добавлен, но ни разу не оплачен
      dateDiffInDays(new Date(), new Date(wallet.dateEnd)) < 0
    )
      toast.warning(
        walletShort(wallet.wallet) +
          " expired on " +
          wallet.dateEnd +
          ". It's no longer shown in Charts and Portfolio.",
        {
          autoClose: 7000,
          toastId: wallet.wallet + wallet.dateEnd, // Prevent duplicate
        }
      );
  }
};
